const { BASE_URL } = require('../constants');

module.exports = {
  bindings: {
    color: '@'
  },
  transclude: true,
  templateUrl: `${BASE_URL}/em-tag/em-tag.template.html`
};